type Props = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};
export const DesktopCheckbox = ({ label, checked, onChange }: Props) => {
  return (
    <label className="flex items-center cursor-pointer text-sm">
      <input
        type="checkbox"
        className="absolute opacity-0 peer"
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <div className="w-4 h-4 mr-2 border border-[#F4EAE1] rounded-xs p-px peer-checked:border-[#B95733]">
        {checked && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 16 16"
            fill="none"
            className="cursor-pointer"
          >
            <path
              d="M14.0001 3.99983L6.00012 12.9998L2.00012 8.42424"
              stroke="#B95733"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span>{label}</span>
    </label>
  );
};
